import React, { useContext, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { Transition } from 'react-spring/renderprops';
import { withTranslation, Trans } from 'react-i18next';
import {Link} from "react-router-dom";
import Helper from "../utils/helper";

function UserCheckEmailComponent({i18n}, props) {

  const userContext = useContext(UserContext)
  const [email, setEmail] = useState(userContext.user.email);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [emailStatus, setEmailStatus] = useState(true);

  const emailError = (userContext.errors != null && userContext.errors.email != null);
  const inputClassName = emailError ? 'form-control is-invalid' : 'form-control';
  const formClassName = userContext.errors != null ? '' : 'was-validated';

  const inOutlook = false;

  const queryString = window.location.search;
  const appUriFromParams = new URLSearchParams(queryString)?.get('app_uri');
  const decodedAppUriFromParams = Helper.getDecodedValue(appUriFromParams);
  const appUri = Helper.isValidUrl(decodedAppUriFromParams) ? decodedAppUriFromParams : null;

  return (
        <ContentCard title={<Trans i18nKey="sign_in_account" />} text={<Trans i18nKey="suggest_email" />}>
            <form className={formClassName}
                onSubmit={(event)=> {
                event.preventDefault()
                event.stopPropagation()
                userContext.checkUserEmail(email, inOutlook, null, appUri)
                }}>
                <div className="">
                    {loadingStatus &&
                        <div className="d-flex justify-content-center mt-3">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden"><Trans i18nKey="loading" />...</span>
                            </div>
                        </div>
                    }
                    <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
                    <div className="form-floating my-3" style={props} >
                        <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            className={inputClassName}
                            id="emailInput"
                            placeholder="name@example.com" />
                        <label htmlFor="emailInput"><Trans i18nKey="email_address" /></label>
                        {emailError &&
                            <div className="invalid-feedback">
                                {userContext.errors.email.map((error) => (
                                    <span key={error}><Trans i18nKey="email" /> {error}</span>
                                ))}
                            </div>
                        }
                    </div>
                </div>
                <button className="btn btn-primary btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                    <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="sign_in" />
                </button>
                {/*<Link to="/users/sign_up" className="link text-center"><Trans>create_account</Trans></Link>*/}
                <a href={`https://officebooking.com/${i18n.language}/get-started-users/`} target="_blank" class="link text-center text-secondary mt-4 mb-3 d-block mx-auto"><Trans i18nKey="DontHaveAnAccount" /><strong> <Trans i18nKey="SignUpHere" /></strong></a>
                <Link to="/users/sign_in" className="link text-center text-secondary mt-4 mb-3 d-block mx-auto"><Trans i18nKey="sign_in_with_password" /></Link>
            </form>
        </ContentCard>
    );
}

export default withTranslation()(UserCheckEmailComponent);
